import { useMediaQuery } from 'hooks/useMediaQuery'

import MinusIcon from 'components/icons/MinusIcon'
import PlusIcon from 'components/icons/PlusIcon'
import { ZoomGlass, ZoomGlassMinus } from 'components/icons/ZoomGlassIcon'

function ZoomControl({
  zoomIn,
  zoomOut,
  zoomPoint,
  zoomValue,
  isZoomOutMap,
  handleResetZoom
}: {
  zoomIn: () => void
  zoomOut: () => void
  zoomPoint: () => void
  zoomValue: { zoom: number; minZoom: number; maxZoom: number }
  isZoomOutMap: boolean
  handleResetZoom: () => void
}) {
  const { zoom, minZoom, maxZoom } = zoomValue

  const isZoomInDisabled = zoom >= maxZoom - 0.05
  const isZoomOutDisabled = zoom <= minZoom + 0.05
  const matches = useMediaQuery('(min-width: 768px)')
  const getHeightClass = () => {
    if (isZoomOutMap) {
      return matches ? 'h-[42px]' : 'h-[30px]'
    }
    return matches ? 'h-[28px]' : 'h-[24px]'
  }
  return (
    <div
      className={`flex justify-around items-center gap-x-2 ${
        matches ? 'w-[136px]' : 'w-[100px]'
      } ${getHeightClass()} bg-[#0000008C] p-2 rounded-md`}
    >
      <div
        id="zoomin_btn"
        className={`flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200 ${
          isZoomInDisabled
            ? 'opacity-30 cursor-not-allowed'
            : 'cursor-pointer hover:bg-white/20 active:bg-white/30'
        } text-white text-xl font-bold select-none`}
        onClick={isZoomInDisabled ? undefined : zoomIn}
      >
        <PlusIcon className={!isZoomOutMap ? 'scale-75' : 'scale-100'} />
      </div>
      <div
        id="zoomto_btn"
        className="flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200 cursor-pointer hover:bg-white/20 active:bg-white/30 text-white select-none"
        onClick={zoom > minZoom + 0.05 ? handleResetZoom || zoomOut : zoomPoint}
      >
        {zoom > minZoom + 0.05 ? (
          <ZoomGlassMinus
            className={!isZoomOutMap ? 'scale-75' : 'scale-100'}
          />
        ) : (
          <ZoomGlass className={!isZoomOutMap ? 'scale-75' : 'scale-100'} />
        )}
      </div>
      <div
        id="zoomout_btn"
        className={`flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200 ${
          isZoomOutDisabled
            ? 'opacity-30 cursor-not-allowed'
            : 'cursor-pointer hover:bg-white/20 active:bg-white/30'
        } text-white text-xl font-bold select-none`}
        onClick={isZoomOutDisabled ? undefined : zoomOut}
      >
        <MinusIcon className={!isZoomOutMap ? 'scale-75' : 'scale-100'} />
      </div>
    </div>
  )
}

export default ZoomControl
